module.exports = __webpack_public_path__ + "img/bowls.20e98ed7.png";